import { Box, styled } from '@mui/material'

import { Paper as InjectedPaper, Title } from './primitives'
// import AuthButton from '../common/primitives/AuthButton'
import logo from '../assets/logo.png'
import PortalTheme from '../themes/PortalTheme'

const ContentContainer = styled('div')({
  margin: '0 48px 0 48px',
})

const ActionsContainer = styled('div')({
      width: '100%',
      minHeight: '16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '16px',
      // ensure buttons follow flex layout and have consistent spacing
      '& .MuiButton-root': {
        float: 'none',
        marginLeft: 0,
      },
})

const Logo = styled('img')(() => ({
  margin: '8px 16px',
  width: '160px',
  height: 'auto',
}))

const PortalBanner = () => (
  <Box component="header" height="352px" mb="-192px" bgcolor="primary.main">
    <Logo src={logo} alt="Awa logo" />
    {/* <AuthButton sx={{ float: 'right' }} /> */}
  </Box>
)

export const PortalPageFrame = ({
  actions,
  children,
  title,
  Paper = InjectedPaper,
}) => (
  <PortalTheme>
    <PortalBanner />
    <Paper>
      <ContentContainer>
        <Title title={title} />
        {children}
      </ContentContainer>
      <ActionsContainer>{actions}</ActionsContainer>
    </Paper>
  </PortalTheme>
)
